export default "__VITE_ASSET__De1wHkhI__"